<template>
  <!-- Um elemento raiz só: o eslint do projeto ainda roda a regra `vue/no-multiple-template-root`. -->
  <div class="loja">
    <LojaPainel
      :itens="itens"
      :carregando="carregando"
      :erro="erro || ''"
      :saldo="saldo"
      :nivel-do-jogador="nivel"
      :efeito-de-preco="efeitoDePreco"
      moeda="ouro"
      icone-vazio="ship"
      @selecionar="comentarSelecao"
      @comprar="pedirConfirmacao"
      @bloqueado="comentarBloqueio"
      @recarregar="carregar"
    />

    <!--
      O D11: **ação reversível não pede confirmação.** Comprar gasta moeda e não volta atrás, então
      a confirmação fica — é exatamente o caso que a regra preserva.
    -->
    <PurchaseConfirmModal
      v-if="mostrarConfirmacao"
      :show="mostrarConfirmacao"
      :item="itemEscolhido"
      :quantity="quantidadeEscolhida"
      :total-price="precoTotal"
      @confirm="confirmar"
      @cancel="mostrarConfirmacao = false"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import LojaPainel from './LojaPainel.vue';
import PurchaseConfirmModal from '../components/PurchaseConfirmModal.vue';
import { falaDoLojista } from './falas';

/**
 * **GERADO** por `tools/varreduras/gerar-lojas.mjs`. Mudou o formato? Mude o gerador.
 *
 * As seis lojas fazem a mesma coisa e divergiam em seis cabeçalhos, seis pílulas de ouro e seis
 * paredões de card (UI-15, UI-16). Agora a apresentação é uma só — o `LojaPainel` (D16) — e o que
 * sobra aqui é o que de fato distingue esta loja: de onde vem a lista, qual moeda paga, e o que a
 * action de compra espera.
 *
 * O ouro **não** é redesenhado aqui: ele mora no `FishHud` do cabeçalho (UI-16, 3.8).
 */
export default {
  name: 'BoatShop',
  components: { LojaPainel, PurchaseConfirmModal },
  emits: ['interact', 'recado'],
  data() {
    return {
      /** A chave desta loja no i18n — de onde saem as falas do lojista (`falas.js`). */
      tipo: 'boat',
      mostrarConfirmacao: false,
      itemEscolhido: null,
      quantidadeEscolhida: 1,
      precoTotal: 0,
      efeitoDePreco: 0,
    };
  },
  computed: {
    ...mapState({
      itens: (state) => (state.shop.boats || []),
      carregando: (state) => state.shop.isLoading,
      erro: (state) => state.shop.error,
      saldo: (state) => state.player.gold,
      nivel: (state) => state.player.level || 1,
    }),
  },
  async mounted() {
    await this.carregar();
  },
  methods: {
    async carregar() {
      await Promise.all([
        this.$store.dispatch('shop/fetchBoats').catch(() => {}),
        this.$store
          .dispatch('shop/calculateBoatPriceEffect')
          .then((v) => { this.efeitoDePreco = v || 0; })
          .catch(() => { this.efeitoDePreco = 0; }),
      ]);
    },
    /** Cada fala é **sorteada** entre as do lojista, e nunca a mesma duas vezes seguidas. */
    dizer(chave, params) {
      this.$emit('recado', falaDoLojista(this, this.tipo, chave, params));
    },
    comentarSelecao(item) {
      this.dizer('about', { name: item.name });
    },
    comentarBloqueio(motivo) {
      if (motivo) this.dizer('cannot', { reason: motivo });
    },
    /**
     * `unidades` e não `quantidade`: onde o catálogo vende **pacotes** — a Premium
     * vende o mesmo tônico em embalagens de 1, 10 e 25, e o modal precisa dizer o que o jogador
     * leva ("10x"), não quantos pacotes ele clicou. Quem sabe a diferença é o painel; nas lojas
     * que não vendem pacote os dois números coincidem.
     */
    pedirConfirmacao({ item, quantidade, total, unidades }) {
      this.itemEscolhido = item;
      this.quantidadeEscolhida = unidades || quantidade;
      this.precoTotal = total;
      this.mostrarConfirmacao = true;
    },
    async confirmar() {
      try {
        const resultado = await this.$store.dispatch('shop/purchaseBoat', { boatId: this.itemEscolhido.id, price: this.precoTotal });
        // As actions divergem no retorno: umas devolvem `true`, outras `{ success }`. Aceitar as
        // duas formas aqui é mais honesto que fingir que já foram uniformizadas.
        const ok = resultado === true || resultado?.success === true;
        if (ok) {
          this.dizer('bought', { name: this.itemEscolhido.name });
          this.mostrarConfirmacao = false;
        } else {
          this.dizer('failed');
        }
      } catch {
        // O erro vira fala do NPC em vez de um alerta genérico: é o mesmo dado, dito por alguém.
        this.dizer('failed');
      }
    },
  },
};
</script>
